export default "__VITE_ASSET__clutcBnF__"